var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-5 icon-slider"},[_c('ul',_vm._l((_vm.images),function(image){return _c('li',{key:image},[_c('MovingIcon',{attrs:{"icon":image,"limit":""}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }